export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-35d24308fc9816a51efda416e0dadc11.svg";